import ReactGTMModule from 'react-gtm-module';

class TagManager {
  constructor() {
    //@ts-ignore
    this.reactGTMModule = ReactGTMModule;
  }

  initialize(gtmId: string): void {
    //@ts-ignore
    this.dl = window.dataLayer || (window.dataLayer = []);
    //@ts-ignore
    this.reactGTMModule.initialize({ gtmId, dataLayer: this.dl });
  }

  dataLayer(params: Record<string, any>): void {
    //@ts-ignore
    this.reactGTMModule.dataLayer({
      dataLayer: params
    });
  }
}

export default TagManager;
